import { clone } from '@jkhy/frontend-utils/functions';
import { InformationReportingProductFeatureModelDto } from '@treasury/api/bo';
import { Account } from '../../../account/entities/account.entity';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: InformationReportingProductFeatureModelDto = {
    enableIntuitFormattedExports: false,
    id: 0,
    type: 'InformationReportingProductFeature',
    productUniqueId: '',
    isConfigurable: true,
};
export class ReportingProductFeature extends CompanyProductFeature<InformationReportingProductFeatureModelDto> {
    constructor(dto: InformationReportingProductFeatureModelDto = clone(defaultDto)) {
        super(dto);
    }

    protected override requiresAccountAddOnSetup = true;

    public get enableIntuitFormattedExports(): boolean {
        return this.dto.enableIntuitFormattedExports;
    }

    public set enableIntuitFormattedExports(value: boolean) {
        this.dto.enableIntuitFormattedExports = value;
    }

    public get accounts(): Account[] {
        return this.dto.accounts?.map(account => new Account(account)) ?? [];
    }

    public set accounts(value: Account[]) {
        this.dto.accounts = value.map(account => account.toDto());
    }

    public override get isSetupRequired(): boolean {
        return this.accounts.length === 0;
    }
}
